import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Input, Spinner } from 'reactstrap'
import { searchCep } from '../../../pages/Profile/utils/cepUtils'

const CepField = ({ value, onChange, onAddressChange, ...props }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [lookupError, setLookupError] = useState(null)

  const formatCep = (v) => {
    const numbers = v.replace(/\D/g, '')
    return numbers.length <= 5 ? numbers : `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`
  }

  const handleCepChange = async (e) => {
    const rawValue = e.target.value.replace(/\D/g, '')
    const formattedValue = formatCep(rawValue)

    // Update the input value directly
    e.target.value = formattedValue
    onChange(e)
    setLookupError(null)

    if (rawValue.length === 8) {
      setIsLoading(true)
      const result = await searchCep(rawValue)
      setIsLoading(false)

      if (result.success) {
        // Only pass fields the provider actually returned — small towns often
        // have a single CEP with no street/neighborhood, and spreading
        // `undefined` used to end up saved as the string "undefined".
        const d = result.data || {}
        const patch = {}
        if (d.state) patch.state = d.state
        if (d.city) patch.city = d.city
        if (d.street) patch.address1 = d.street
        if (d.neighborhood) patch.neighborhood = d.neighborhood
        onAddressChange(patch)
      } else {
        // Don't block the form — the user can still type the address by hand.
        setLookupError('CEP não encontrado. Confira o número ou preencha o endereço manualmente.')
      }
    }
  }

  return (
    <div className="position-relative">
      <Input
        inputMode="numeric"
        autoComplete="postal-code"
        {...props}
        value={value || ''}
        onChange={handleCepChange}
        maxLength={9}
        aria-describedby={lookupError ? `${props.id || props.name}-cep-error` : undefined}
      />
      {isLoading && (
        <Spinner
          size="sm"
          className="position-absolute"
          style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}
        />
      )}
      {lookupError && (
        <div id={`${props.id || props.name}-cep-error`} className="text-warning small mt-1" role="status">
          <i className="bx bx-info-circle me-1" aria-hidden="true" />{lookupError}
        </div>
      )}
    </div>
  )
}

CepField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onAddressChange: PropTypes.func.isRequired
}

export default CepField
